import { Tag } from 'antd';
import type React from 'react';

interface DriverWithDistrictsViewProps {
  drivers: { driverName: string; driverId: string }[];
}

export const DriverWithDistrictsViewNew: React.FC<DriverWithDistrictsViewProps> = ({ drivers }) => {
  return (
    <div style={{ flexWrap: 'wrap', display: 'flex', gap: 4 }}>
      {drivers.map((driver) => (
        <Tag
          key={driver.driverId}
          color={'blue'}
          style={{
            whiteSpace: 'normal',
            alignSelf: 'flex-start',
          }}
        >
          {driver.driverName}
        </Tag>
      ))}
    </div>
  );
};
